import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cd908b8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title-3" }, "Page des téléchargements", -1))
const _hoisted_2 = { class: "d-flex flex-col align-center" }

import { useUser } from "@/domains/auth/user";
import Cfcrhb from "../components/Cfcrhb.vue";
import KmReport from "../components/KmReport.vue";
import KmReportDetails from "../components/KmReportDetails.vue";
import NegativeStates from "../components/NegativeStates.vue";
import { ROLE_ADMIN } from "@/domains/cruds/users/users";
import IdleUsers from "../components/IdleUsers.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { user } = useUser();
const paidTripEnabled = process.env.VUE_APP_ENABLE_PAID_TRIPS === "true";

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      paidTripEnabled
        ? (_openBlock(), _createBlock(KmReport, { key: 0 }))
        : _createCommentVNode("", true),
      paidTripEnabled
        ? (_openBlock(), _createBlock(KmReportDetails, { key: 1 }))
        : _createCommentVNode("", true),
      _createVNode(Cfcrhb),
      (_unref(user)?.roles.includes(_unref(ROLE_ADMIN)))
        ? (_openBlock(), _createBlock(NegativeStates, { key: 2 }))
        : _createCommentVNode("", true),
      (_unref(user)?.roles.includes(_unref(ROLE_ADMIN)))
        ? (_openBlock(), _createBlock(IdleUsers, { key: 3 }))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})